var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card float-left ml-3 card-chat-booking" },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))]),
        _vm._v(" "),
        _vm.order
          ? _c(
              "section",
              [
                _c(
                  "div",
                  { ref: "actionMenus", class: { "pt-2": _vm.menuCount } },
                  [
                    _c("received-order-section", {
                      staticClass: "text-small",
                      attrs: { order: _vm.order, includeCssClass: false }
                    }),
                    _vm._v(" "),
                    _c("review-section", {
                      staticClass: "text-small",
                      attrs: { order: _vm.order, includeCssClass: false }
                    }),
                    _vm._v(" "),
                    _c("professional-tip-section", {
                      attrs: { order: _vm.order, includeCssClass: false }
                    }),
                    _vm._v(" "),
                    _vm.canBookAdditionalHours(_vm.order)
                      ? _c("div", [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info btn-block",
                              on: {
                                click: function($event) {
                                  return _vm.openOrderAdditionalHoursModal(
                                    _vm.order
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.my_reservations.book_additional_hours"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.order.paid_status === 1 &&
                    _vm.order.is_no_datetime_booking === 1 &&
                    _vm.order.status === 0
                      ? _c("div", [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info btn-block",
                              on: {
                                click: function($event) {
                                  return _vm.openUpdateServiceDateTimeModal()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.button.select_service_datetime"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.order.professional_id &&
                    (_vm.parentServiceId === 2 ||
                      (_vm.parentServiceId === 1 && _vm.order.extras === 2))
                      ? _c("div", [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info btn-block",
                              class: { "mt-2": _vm.$mq.phone },
                              on: {
                                click: function($event) {
                                  return _vm.openPurchaseServiceModal()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.my_reservations.book_additional_ironing_service"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _vm._v("\n        #" + _vm._s(_vm.order.order_code) + " - "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$options.filters.serviceParentName(
                          _vm.order.service_id,
                          _vm.globalState.services
                        )
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2 no-gutters" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.my_reservations.status")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.orderStatus(_vm.order)
                        )
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm.order.package
                  ? _c("div", { staticClass: "row mb-4 no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-3 text-left text-orange" },
                        [
                          _c("i", { staticClass: "fal fa-layer-group" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("message.my_reservations.package")
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9 text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.my_reservations.package")) +
                            " #" +
                            _vm._s(_vm.order.package.id) +
                            " - " +
                            _vm._s(
                              _vm._f("multiLangName")(
                                _vm.order.package.package_type
                              )
                            ) +
                            "\n          "
                        ),
                        _vm.order.package.package_type.category === "unlimited"
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.package_count",
                                      { count: _vm.order.package.orders.length }
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.order.package.package_type.category === "unlimited"
                        ? _c("div", { staticClass: "col-12 text-right" }, [
                            _c(
                              "ul",
                              { staticClass: "list-unstyled" },
                              _vm._l(_vm.order.package.orders, function(
                                order,
                                index
                              ) {
                                return _c("li", [
                                  order.cleaning_date
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("prettyDate")(
                                              order.cleaning_date
                                            )
                                          )
                                        )
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "text-orange" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.my_reservations.booking_date_not_specified"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-pill",
                                      class:
                                        order.status === 2
                                          ? "badge-success"
                                          : "badge-warning"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            order.status === 2
                                              ? _vm.$t(
                                                  "message.my_reservations.past"
                                                )
                                              : _vm.$t(
                                                  "message.my_reservations.upcoming"
                                                )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2 no-gutters" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("message.my_reservations.cleaning_date"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _vm.order.cleaning_date
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("prettyDate")(_vm.order.cleaning_date)
                            )
                          )
                        ])
                      : _c("span", { staticClass: "text-orange" }, [
                          _vm._v("ยังไม่ระบุวันที่รับบริการ")
                        ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2 no-gutters" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _vm.order.service_id === 1
                      ? _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.my_reservations.duration"))
                          )
                        ])
                      : _vm.order.order_service_items
                      ? _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.service_item.list_of_items"))
                          )
                        ])
                      : _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.booking.booking_step.service")
                            )
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _vm.order.service_id === 1
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.order.work_hour) +
                              " " +
                              _vm._s(
                                _vm.$tc("message.hour", _vm.order.work_hour)
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm.order.order_service_items
                      ? _c(
                          "span",
                          [
                            _vm._l(_vm.order.order_service_items, function(
                              orderServiceItem
                            ) {
                              return _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("multiLangName")(
                                        orderServiceItem.service_item
                                      )
                                    ) +
                                    " " +
                                    _vm._s(orderServiceItem.quantity) +
                                    " \n              " +
                                    _vm._s(
                                      _vm._f("multiLangName")(
                                        orderServiceItem.service_item.item_unit
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-info text-small" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.service_item.remark"))
                              )
                            ])
                          ],
                          2
                        )
                      : _c("span", [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.serviceParentName(
                                  _vm.order.service_id,
                                  _vm.globalState.services
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm._f("multiLangName")(
                                  _vm.globalState.services[_vm.order.service_id]
                                )
                              )
                            )
                          ])
                        ])
                  ])
                ]),
                _vm._v(" "),
                _c("order-additional-hours", {
                  ref: "orderAdditionalHours",
                  attrs: { order: _vm.order }
                }),
                _vm._v(" "),
                _vm.order.professional
                  ? _c("div", { staticClass: "row mb-2 no-gutters" }, [
                      _c("div", { staticClass: "col-4 mt-2 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.my_reservations.cleaner"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-right" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-end align-items-center"
                          },
                          [
                            _c("div", [
                              _c("img", {
                                staticClass: "rounded-circle",
                                class:
                                  _vm.order.declined_order_data &&
                                  _vm.order.status === 0
                                    ? "border border-danger"
                                    : "",
                                attrs: {
                                  src: _vm.order.professional.full_picture,
                                  alt: "",
                                  width: "40"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pl-2" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("firstName")(
                                      _vm.order.professional_name
                                    )
                                  ) +
                                  "\n              "
                              ),
                              _vm.order.status === 0 &&
                              _vm.order.cleaning_date &&
                              !_vm.order.declined_order_data
                                ? _c("div", { staticClass: "text-small" }, [
                                    _c(
                                      "div",
                                      { staticClass: "-status-pending" },
                                      [
                                        _vm._m(0),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.my_reservations.waiting"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm.order.status > 0
                                ? _c("div", {
                                    staticClass: "text-small",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$options.filters.professionalJobStatus(
                                          _vm.order,
                                          true
                                        )
                                      )
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.declined_order_data && _vm.order.status === 0
                  ? _c("div", [
                      _vm.order.selected_professional_id
                        ? _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "text-order-notification" },
                                [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "-status-alert" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.declined_booking.cleaner_declined_booking"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "-status-alert mt-1" },
                                    [
                                      _vm._v(
                                        "\n                - " +
                                          _vm._s(
                                            _vm._f("declinedReason")(
                                              _vm.order.declined_order_data
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-4 text-left" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.my_reservations.cleaner")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-8 text-primary text-right" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.my_reservations.finding_new_cleaner"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.status === 0 &&
                (_vm.order.pre_booking_professionals ||
                  _vm.order.declined_order_data)
                  ? _c("div", { staticClass: "row pb-4 no-gutters" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("pre-booking-professional-selection-section", {
                            attrs: { imgSize: 48, order: _vm.order }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2 no-gutters" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("message.my_reservations.customer_name"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 text-right" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.order.customer_name) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2 no-gutters" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.my_reservations.customer_address")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 pl-3 text-left" }, [
                    _vm.order.place_name
                      ? _c("p", [_vm._v(_vm._s(_vm.order.place_name))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm._f("multiLangName")(
                            _vm.$t(
                              _vm.globalState.placeSizes[
                                _vm.order.place_size_id
                              ]
                            )
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.order.address))])
                  ])
                ]),
                _vm._v(" "),
                _vm.order.user_place.pet_remark
                  ? _c("div", { staticClass: "row mb-2 no-gutters" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.my_reservations.pet")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-left" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.order.user_place.pet_remark) +
                            "\n        "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.remark
                  ? _c("div", { staticClass: "row mb-2 no-gutters" }, [
                      _c("div", { staticClass: "col-4 text-left" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.my_reservations.remark"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 text-left" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.order.remark) +
                            "\n        "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.customer_area_photos
                  ? _c(
                      "div",
                      { staticClass: "mb-2" },
                      [
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.checkout_step.customer_area_photos"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("photos-album", {
                          attrs: {
                            photos: _vm.order.customer_area_photos,
                            photoType: "order_photos",
                            includeGallery: true
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.status === 2 &&
                _vm.order.order_photos &&
                _vm.order.sent_photo_status === 1
                  ? _c(
                      "div",
                      { staticClass: "mb-2" },
                      [
                        _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.checkout_step.completed_cleaning_photos"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("photos-album", {
                          attrs: {
                            photos: _vm.order.order_photos,
                            photoType: "order_photos",
                            includeGallery: true
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row my-2 no-gutters" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("div", [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.my_reservations.payment"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.order
                        ? _c("order-summary-total", {
                            attrs: { order: _vm.order }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.order.professional_tip &&
                _vm.order.professional_tip.paid_status
                  ? _c("div", { staticClass: "row no-gutters" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("label", { staticClass: "mb-0" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.professional_tip.amount"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("currency")(
                                Number(_vm.order.professional_tip.amount)
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.purchases.length > 0
                  ? _c("div", { staticClass: "row no-gutters" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.my_reservations.other_payments")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [_c("order-purchase", { attrs: { order: _vm.order } })],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("section", [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-info btn-block",
              on: {
                click: function($event) {
                  return _vm.backToMainMenu()
                }
              }
            },
            [_vm._v("กลับสู่เมนูหลัก")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("select-service-date-time-modal", {
        ref: "selectServiceDateTimeModal",
        on: {
          onUpdatedOrder: function($event) {
            return _vm.performUpdateOrder()
          }
        }
      }),
      _vm._v(" "),
      _c("purchase-service-modal", {
        ref: "purchaseServiceModal",
        attrs: { parentServiceId: 2 },
        on: {
          onUpdatedOrder: function($event) {
            return _vm.performUpdateOrder()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle -status-pending" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle -status-alert" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c77b771a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c77b771a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/OrderDetailMessage.vue
// module id = 2106
// module chunks = 0